var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooksIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.349,
    height: 18.729,
    viewBox: "0 0 16.349 18.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11430",
    "data-name": "Group 11430",
    transform: "translate(-213.954 -118.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    d: "M1.454.145A1.31,1.31,0,0,0,.145,1.454V15.7A1.31,1.31,0,0,0,1.454,17.01h3.2A1.31,1.31,0,0,0,5.961,15.7V1.454A1.31,1.31,0,0,0,4.652.145h-3.2m0-.145h3.2A1.454,1.454,0,0,1,6.106,1.454V15.7a1.454,1.454,0,0,1-1.454,1.454h-3.2A1.454,1.454,0,0,1,0,15.7V1.454A1.454,1.454,0,0,1,1.454,0Z",
    transform: "translate(214.204 119.422)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    d: "M1.454.145A1.31,1.31,0,0,0,.145,1.454V15.7A1.31,1.31,0,0,0,1.454,17.01h3.2A1.31,1.31,0,0,0,5.961,15.7V1.454A1.31,1.31,0,0,0,4.652.145h-3.2m0-.145h3.2A1.454,1.454,0,0,1,6.106,1.454V15.7a1.454,1.454,0,0,1-1.454,1.454h-3.2A1.454,1.454,0,0,1,0,15.7V1.454A1.454,1.454,0,0,1,1.454,0Z",
    transform: "matrix(0.97, -0.242, 0.242, 0.97, 219.925, 120.416)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    d: "M1.308.145A1.163,1.163,0,1,0,2.472,1.308,1.164,1.164,0,0,0,1.308.145m0-.145A1.308,1.308,0,1,1,0,1.308,1.308,1.308,0,0,1,1.308,0Z",
    transform: "translate(215.949 131.925)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    d: "M.363.145a.218.218,0,0,0,0,.436H2.544a.218.218,0,0,0,0-.436H.363M.363,0H2.544a.363.363,0,0,1,0,.727H.363A.363.363,0,0,1,.363,0Z",
    transform: "translate(215.803 121.603)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    d: "M.363.145a.218.218,0,0,0,0,.436H2.544a.218.218,0,0,0,0-.436H.363M.363,0H2.544a.363.363,0,0,1,0,.727H.363A.363.363,0,0,1,.363,0Z",
    transform: "matrix(0.97, -0.242, 0.242, 0.97, 222.004, 122.145)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    d: "M.363.145a.218.218,0,0,0,0,.436H2.544a.218.218,0,0,0,0-.436H.363M.363,0H2.544a.363.363,0,0,1,0,.727H.363A.363.363,0,0,1,.363,0Z",
    transform: "translate(215.803 123.202)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    d: "M.363.145a.218.218,0,0,0,0,.436H2.544a.218.218,0,0,0,0-.436H.363M.363,0H2.544a.363.363,0,0,1,0,.727H.363A.363.363,0,0,1,.363,0Z",
    transform: "matrix(0.97, -0.242, 0.242, 0.97, 222.391, 123.697)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    d: "M.363.145a.218.218,0,0,0,0,.436H2.544a.218.218,0,0,0,0-.436H.363M.363,0H2.544a.363.363,0,0,1,0,.727H.363A.363.363,0,0,1,.363,0Z",
    transform: "translate(215.803 124.656)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    d: "M.363.145a.218.218,0,0,0,0,.436H2.544a.218.218,0,0,0,0-.436H.363M.363,0H2.544a.363.363,0,0,1,0,.727H.363A.363.363,0,0,1,.363,0Z",
    transform: "matrix(0.97, -0.242, 0.242, 0.97, 222.743, 125.107)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksIcon);
export default __webpack_public_path__ + "static/media/BooksIcon.cf9cdad37177270fee5f66cddf385faa.svg";
export { ForwardRef as ReactComponent };